__turbopack_context__.v({
  "icon": "a4hrnG_icon",
});
